export default __webpack_public_path__ + "./assets/homepage-about__e2632a4567c87c284c7ba33e2358dfa3.png";